__turbopack_context__.v({
  "container": "styles-module__JxRFEa__container",
  "image": "styles-module__JxRFEa__image",
  "label": "styles-module__JxRFEa__label",
  "title": "styles-module__JxRFEa__title",
});
